import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 1,
        ease: "power2.inOut"
      },
      scrollTrigger: {
        trigger: "#icon-clock",
        start: "top center",
        end: "bottom center",
        markers: false,
        // onEnter, onLeave, onEnterBack, onLeaveBack
        // toggleActions: "play none reset play"
        toggleActions: "play none play reset"
      }
    }).to('.clock-icon-pivot', {
        duration: 1.5,
        // rotate clock hands
        rotate: 1080,
        transformOrigin: "center center",

      })
    });

 return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.04 149.7" width="100" id="icon-clock">
        <path d="M74.21,149.7c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75c31.62,0,57.34-25.72,57.34-57.34s-25.72-57.34-57.34-57.34-57.34,25.72-57.34,57.34c0,2.72.2,5.48.59,8.19.21,1.5-.83,2.89-2.33,3.11-1.5.21-2.89-.83-3.11-2.33-.43-2.97-.64-5.99-.64-8.97,0-34.65,28.19-62.83,62.83-62.83s62.83,28.19,62.83,62.83-28.19,62.83-62.83,62.83h0Z" fill="#001e5d" stroke-width="0"/>
        <path d="M74.21,149.7h-34.33c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75h34.33c1.52,0,2.75,1.23,2.75,2.75s-1.23,2.75-2.75,2.75Z" fill="#001e5d" stroke-width="0"/>
        <path d="M49.34,132.53H15c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75h34.33c1.52,0,2.75,1.23,2.75,2.75s-1.23,2.75-2.75,2.75h0Z" fill="#001e5d" stroke-width="0"/>
        <path d="M37.08,115.36H2.75c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75h34.33c1.52,0,2.75,1.23,2.75,2.75s-1.23,2.75-2.75,2.75Z" fill="#001e5d" stroke-width="0"/>
        <path d="M74.21,135.96c-1.52,0-2.75-1.23-2.75-2.75s1.23-2.75,2.75-2.75c24.04,0,43.6-19.56,43.6-43.6,0-5.77-1.11-11.39-3.31-16.69-.58-1.4.08-3.01,1.49-3.59,1.4-.58,3.01.08,3.59,1.49,2.48,5.97,3.73,12.3,3.73,18.79,0,27.07-22.03,49.1-49.1,49.1Z" fill="#001e5d" stroke-width="0"/>
        <path d="M129.57,38.8l-7.28-7.28c-1.07-1.07-2.81-1.07-3.88,0-1.07,1.07-1.07,2.81,0,3.88l1.7,1.7-5.34,5.34,3.88,3.88,5.34-5.34,1.7,1.7c.54.54,1.24.8,1.94.8s1.41-.27,1.94-.8c1.07-1.07,1.07-2.81,0-3.88Z" fill="#001e5d" stroke-width="0"/>
        <path d="M33.67,42.44l-5.34-5.34,1.7-1.7c1.07-1.07,1.07-2.81,0-3.88s-2.81-1.07-3.88,0l-7.28,7.28c-1.07,1.07-1.07,2.81,0,3.88.54.54,1.24.8,1.94.8s1.41-.27,1.94-.8l1.7-1.7,5.34,5.34s3.88-3.88,3.88-3.88Z" fill="#001e5d" stroke-width="0"/>
        <path d="M86.23,0h-24.03c-2.46,0-4.46,2-4.46,4.46v10.3c0,2.46,2,4.46,4.46,4.46h2.4v10.3h19.23v-10.3h2.4c2.46,0,4.46-2,4.46-4.46V4.46c0-2.46-2-4.46-4.46-4.46ZM78.33,24.03h-8.24v-4.81h8.24v4.81ZM85.2,13.73h-21.97V5.49h21.97v8.24Z" fill="#001e5d" stroke-width="0"/>
        <g class="clock-icon-pivot">
            <rect id="d" data-name="pivot" x="40.29" y="53.33" width="68.26" height="68.26" fill="none" stroke-width="0"/>
            <path d="M106.5,54.58c-1.07-1.07-2.81-1.07-3.88,0l-22.58,22.58c-4.35-2.61-10.09-2.05-13.83,1.69-2.14,2.14-3.32,4.99-3.32,8.01,0,2.09.57,4.08,1.62,5.82l-3.16,3.16c-1.07,1.07-1.07,2.81,0,3.88.54.54,1.24.8,1.94.8s1.41-.27,1.94-.8l3.16-3.16c1.79,1.07,3.8,1.62,5.82,1.62,2.9,0,5.8-1.1,8.01-3.31s3.32-4.99,3.32-8.01c0-2.09-.57-4.08-1.62-5.82l22.58-22.58c1.07-1.07,1.07-2.81,0-3.88ZM78.34,91h0c-2.28,2.28-5.98,2.28-8.25,0-2.28-2.28-2.28-5.98,0-8.25,1.14-1.14,2.63-1.71,4.13-1.71s2.99.57,4.13,1.71h0c1.1,1.1,1.71,2.57,1.71,4.13s-.61,3.02-1.71,4.13h0Z" fill="#001e5d" stroke-width="0"/>
        </g>
    </svg>
 );
}